import { SummaryRow } from '../../../../Summary/SummaryRow';
import { VQ } from '../../../../../store/student/types';
import { IVisaPrepForm } from '../../../../../types';
import { useTranslation } from "react-i18next";

function VisaPrepAdditionalHistoryStep1Info(props: IVisaPrepForm) {
    const { t } = useTranslation('forms.visa');
  return (
    <SummaryRow
      className={'visa-summary'}
      key={VQ.NON_HOME_COUNTRY_APP_DESC}
      value={props.nonHomeCountryApplicationDesc}
      label={t('forms.visa:immigrationStatusAndExpiryDate')}
      fullLabel={
        'Please explain your visa/immigration status for the country you are applying from, and the expiry date of any visas you hold for this country'
      }
    />
  );
}

export default VisaPrepAdditionalHistoryStep1Info;
